import { connect } from "react-redux";

import InfoSectionInfoOwnership from "../../components/InfoSectionInfoOwnership";
import { activateCaptcha } from "../CaptchaWrapper/actions";

const mapStateToProps = (state, props) => ({
  isAddition: state.modalSection[props.modalId].conf.isAddition,
  userUuid: state.user.uuid,
  user: state.user,
  theme: state.theme
});

const mapDispatchToProps = {
  activateCaptcha
};

const InfoSectionInfoOwnershipWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoSectionInfoOwnership);

export default InfoSectionInfoOwnershipWrapper;
